import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { boat_details } from './boats.schema';

export const trips = sqliteTable('trips', {
  id: text('id').notNull().primaryKey(),
  name: text('name'),
  origin: text('origin'),
  laravel_id: integer('laravel_id'),
  origin_longitude: real('origin_longitude'),
  origin_latitude: real('origin_latitude'),
  started_at: text('started_at'),
  closed_at: text('closed_at'),
  finished_at: text('finished_at'),
  auto_logging: integer('auto_logging'),
  /**
   * `0` on a row the backend refused to accept as written. It keeps such a row rather than
   * dropping the user's write, strips the fields that failed (`started_at` among them) and
   * files a `sync_errors` row against it — so a disabled trip is a broken draft awaiting a fix,
   * not a trip. Synced so the conflict checks can tell the two apart; see
   * `useTripByDateAndBoatQuery`.
   *
   * The backend owns the column with one exception: saving a repair from the edit form withdraws
   * the refusal locally, rather than leaving the fixed trip out of those checks until the server
   * has answered. See `clearTripRejection`.
   */
  is_enabled: integer('is_enabled'),
  skipper_id: integer('skipper_id'),
  crewman_id: integer('crewman_id'),
  boat_detail_id: integer('boat_detail_id'),
  boat_detail_uuid: text('boat_detail_uuid').references(() => boat_details.id),
  user_id: integer('user_id'),
  organization_id: text('organization_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  destination: text('destination'),
  destination_longitude: real('destination_longitude'),
  destination_latitude: real('destination_latitude'),
  image_id: integer('image_id'),
  image_uuid: text('image_uuid'),
  notes: text('notes'),
});
